import type { ZervantSettingsFields } from '../../../types/zervantSettingsFields'

export const getDocumentTypeSettingsColumnNames = (fields: ZervantSettingsFields): string[] => {
  return (fields.columns?.default ?? '').split(',').filter(Boolean)
}
